export const validatePassword = (password) => {
  if (password.length < 8) return 'Password must be at least 8 characters.';
  if (!/[A-Z]/.test(password)) return 'Password needs 1 uppercase letter.';
  if (!/[0-9]/.test(password)) return 'Password needs 1 number.';
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) return 'Password needs 1 symbol (!@#...).';
  return null;
};
